import useFilters from '../../../hook/useFilters'
import useApi from '../../../services/useApi'
import {parseProductReportData} from '../utils'

const useGetProductReport = () => {
  const Api = useApi()

  const initialFilters = {
    page: 1,
    limit: 30,
    sort_by: 'total/-1',
    search: '',
  }

  const {filters, onSearch, onSortingChange, onPageChange} = useFilters(initialFilters, {
    sortType: 'number'
  })

  const {data: response, isFetching} = Api.useGetQuery('/products/inquiries/product-report', {
    filters: filters,
  })

  return {
    productData: parseProductReportData(response?.data || []),
    pagination: response?.pagination || {},
    isLoading: isFetching,
    filters,
    searchValue: filters.search,
    onSearch,
    onSortingChange,
    onPageChange,
  }
}

export default useGetProductReport
